import PurchasedDataUnit from "./purchasedDataUnit";
import PurchasedDataUnit_Details from "./PurchasedDataUnit_Details";
const purchasedDataUnit ={
     PurchasedDataUnit,
     PurchasedDataUnit_Details
}
export default purchasedDataUnit